function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  fill: "#F2CD5D",
  enableBackground: "new    ",
  d: "M455.3,33.6C411.8,16,365.8,1.3,318.9,3.1 c-69,2.7-135.2,44-167.7,104.7c-27.5,51.4-30.9,111.7-42.8,168.7C93.9,346.8,65.9,413.6,36,479C19.9,514.1,3,549.9,0.3,588.4 c-3.7,53.4,22,106.6,62.2,142.2c40.2,35.5,93.6,54.3,147.2,58.4c28.5,2.2,58.3,0.2,83.6-13.1c26.8-14,46.3-39.3,73.2-53 c24.9-12.8,54.1-14.6,82.1-12.9c36.6,2.2,72.6,9.8,107.2,22.7c39.1,14.6,75.5,35.8,114.5,50.7s82.7,23,122.6,10.6 c37.5-11.6,67.1-39.9,93.8-68.5c43.7-46.7,83.7-97.1,119.7-150.7c24.1-35.9,46.5-73.9,57.2-115.8c20.4-80.1-7.7-170.5-69.8-225.2 c-51.5-45.3-120.7-65-188.3-76.9C743.8,146,672.4,145.3,615.6,117C561.4,90,512.1,56.6,455.3,33.6z"
});

var _ref3 = /*#__PURE__*/React.createElement("title", null, "hire");

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  fill: "#3F3D56",
  cx: 679.6,
  cy: 733.3,
  rx: 389,
  ry: 35
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 509.4,
  y: 140,
  fill: "#C5C4CC",
  width: 422.2,
  height: 286
}), /*#__PURE__*/React.createElement("rect", {
  x: 779.7,
  y: 166.2,
  fill: "#F2F2F2",
  width: 125,
  height: 136.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 582.1,
  y: 166.2,
  fill: "#F2F2F2",
  width: 120.5,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 779.7,
  y: 323.4,
  fill: "#F2F2F2",
  width: 42.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 781.2,
  y: 338.4,
  fill: "#F2F2F2",
  width: 122,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 557.4,
  y: 196.1,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 557.4,
  y: 219.4,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 557.4,
  y: 242.6,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 557.4,
  y: 265.8,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 557.4,
  y: 289,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 557.4,
  y: 312.2,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 557.4,
  y: 335.4,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M798.5,244c1.9-1.3,3.9-2.3,6.1-3c13.7-5.1,28.1-8.2,42.7-9.3c12.7-0.9,26.4,0.2,36.3,8.1 c1.5,1.1,2.8,2.6,3.7,4.3c1.2,2.7,0.9,5.8,0.5,8.8c-0.1,1.1-0.4,2.3-0.8,3.3c-1.3,2.5-4.6,3.4-7.5,3.1s-5.5-1.5-8.3-2.1 c-1.7-0.3-3.5-0.5-5.3-0.5l-17.6-1c-11-0.6-22.1-1.2-32.8,1c-3.3,0.6-6.5,1.7-9.5,3.3c-2.5,1.4-4.1,3.4-6.4,0.8 C795.4,256.4,793.2,248.1,798.5,244z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M825.8,251.8c0,0,23.7-10.6,32.7,1.6c9,12.2-4.9,7.4-4.9,7.4l-15.5,4.9l-17.2-3.3L825.8,251.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB9B9",
  d: "M827,244c0,0,3.3,15.5,0.8,19.6s13.9,9.8,13.9,9.8l15.5-6.5c0,0-4.1-25.4,0-30.3L827,244z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M827,244c0,0,3.3,15.5,0.8,19.6s13.9,9.8,13.9,9.8l15.5-6.5 c0,0-4.1-25.4,0-30.3L827,244z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB9B9",
  d: "M864.7,228.5c0,13.5-11,24.5-24.5,24.5c-1.5,0-2.9-0.1-4.4-0.4c-13.3-2.4-22.2-15.2-19.8-28.5 s15.2-22.2,28.5-19.8C856.2,206.5,864.7,216.6,864.7,228.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M879.5,303.2h-78.3l1.8-7.7l7.7-33.5l8.9-6l0,0l4.2-2.8l2.1-1.4c0,0,1.2,0.6,2.6,1.3 c0.4,0.2,0.8,0.5,1.3,0.7l0,0c0.7,0.4,1.3,0.8,1.9,1.3c0.1,0.1,0.2,0.2,0.3,0.3c1.6,1.6,6.1,9.8,13.6,5.6c0.4-0.2,0.7-0.4,1.1-0.7 c2-1.4,3.8-2.8,5.6-4.4c1.6-1.4,2.6-2.6,3.4-3.3c0.4-0.4,0.8-0.7,1.3-0.9c0.4-0.2,0.7-0.3,1.1-0.3c2.5,0,5.7,4.9,5.7,4.9l0.1,0.3 l0,0l10.3,31L879.5,303.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M801.2,303.2h23.7c0.1-2.7-0.1-5.5-0.4-8.2c-0.7-5.5-2.5-10.7-3.6-16.1c-1-4.7-1.5-9.6-1.4-14.4 c0-0.7,0-1.3,0.1-2c0.1-1.5,0.5-3,1.3-4.4c0.6-0.9,1.3-1.6,1.9-2.4c0.2-0.3,0.4-0.6,0.5-0.9l0,0c0.1-0.1,0.1-0.3,0.2-0.5 c0.1-0.4,0.2-0.7,0.2-1.1c0.1-2.5-2.1-4.9-4.5-5.9c-3.4-1.3-7.1-1.4-10.6-0.4s-6.8,2.4-10,4.1c-1.1,0.5-2.1,1.1-3.2,1.7 c-1.2,0.7-2.4,1.6-3.3,2.5c-2.5,2.6-3.7,6.3-4.6,9.8c-0.9,2.7-1.1,5.6-0.9,8.4c0,0.1,0,0.2,0,0.3c0.9,4.7,4.7,8.2,6.7,12.5 c2.4,5,2.2,10.8,1.3,16.2c0,0.3-0.1,0.6-0.1,0.8H801.2L801.2,303.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M897.8,273.2c-3,9.8-5.1,19.8-6.5,30h-33.8c-0.9-2.4-1.8-4.8-2.6-7.2c-0.7-1.8-1.3-3.7-1.8-5.6 c-0.5-2.2-0.8-4.4-0.8-6.7c0-0.5,0-1.1,0.1-1.6l0,0c0.2-2.8,0.9-5.6,2-8.3c0.5-1.2,1.1-2.4,1.7-3.5c1.6-2.8,3.5-5.5,5.2-8.3 c1.1-1.7,2-3.5,2.7-5.3l0,0c1-2.4,1.5-4.9,1.5-7.4c-0.1-3.3-5.6-9.1,0.4-8.5c8.3,0.7,15.4,5.5,21.9,11c1.7,1.5,3.4,3,5.1,4.4 c2.6,2.3,5.3,4.8,6,8.2c0.1,0.5,0.2,1.1,0.2,1.6C899.1,268.4,898.6,270.9,897.8,273.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB9B9",
  d: "M847.1,264.2c-0.9-2.3-2.2-4.4-3.8-6.2c-1.7-1.4-3.7-2.5-5.9-3c-2.8-0.8-5.7-1.2-8.6-1.2 c-3.5,0-7.5,0.9-9,4c-1.2,2.5-0.3,5.4,0.9,7.9c0.5,1.3,1.3,2.4,2.4,3.3c1.5,1,3.4,1,5.2,1.3c2.7,0.7,5.3,1.9,7.7,3.5l6.1,3.7 l10.4,6.3c-0.3-0.2-0.2-7.3-0.5-8.5C851,271.6,848.7,267.8,847.1,264.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M864,215.7c-0.4-1.5-1.4-2.7-2.7-3.5c0.1-1.6-0.1-3.1-0.6-4.7c-1.5-4.4-5-4.1-8.3-6.1 c-1.4-0.8-1.4-1.6-2.1-3c-1-1.8-2.5-3.3-4.2-4.3c-2.1-1.4-4.4-2.8-6.9-2.9c-5.3-0.4-9.4,4.6-14.4,6.2c-2.2,0.7-4.6,0.7-6.9,1.4 s-4.5,2.3-4.8,4.6c-0.2,1.1,0.1,2.2,0,3.2c-0.3,2.1-2.2,3.6-3.4,5.4c-2.8,3.9-2.4,9.3-0.2,13.5c0.5,0.9,1,1.7,1.6,2.5 c0.2,2,0.8,3.9,1.7,5.7c2.2,4.2,6,7.3,10,10c-0.3-1.4-0.5-2.8-0.6-4.2c-0.1-0.5,0-1,0.2-1.4c0.4-0.9,1.6-1.2,2.5-1.7 c1.8-1,2.6-3.4,2.6-5.5s-0.4-4.2-0.2-6.4c0-1,0.4-1.9,1.2-2.6c0.7-0.4,1.5-0.6,2.2-0.5c3.8-0.2,7.7-0.2,11.1-2 c1.1-0.7,2.2-1.3,3.4-1.7c2.8-0.7,5.7,1.2,7.4,3.7s2.4,5.3,4,7.8s4.1,4.7,7,4.4c0.3,0,0.6-0.1,0.9-0.4c0.1-0.2,0.2-0.5,0.2-0.7 l0.2-11.1C864.7,219.5,864.5,217.5,864,215.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M799.3,290c0.5,4.4,0.9,8.8,1,13.2h-20.6v-17.3c0.1-0.4,0.2-0.8,0.4-1.2c1.3-4,4-7.3,6.3-10.7 c0.1-0.2,0.2-0.3,0.3-0.5c1-1.5,1.9-3,2.6-4.6c0.3-0.8,0.9-4.6,1.4-5c2.4-1.4,4.4,4.6,4.8,6c1.2,4.8,2.2,9.6,3,14.5 C798.8,286.2,799.1,288.1,799.3,290z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M903.4,303.2h-47.3c-0.4-1-0.8-1.9-1.2-2.8c-2.9-6.7-6.8-12.9-11.3-18.6c-0.8-0.8-1.2-1.7-1.4-2.8 c0-0.4,0.1-0.9,0.3-1.3c0.7-1.3,2.6-2.1,4.2-2.8c1.6-0.6,3.1-1.6,4.3-2.7c1.1-1,2-2.3,2.5-3.7c0.1-0.4,0.2-0.8,0.3-1.3 c0.2,0.3,0.4,0.6,0.7,0.9c0.5,0.7,1.1,1.4,1.6,2.1c5.2,6.7,11,13.4,18.2,17.4c1.9,1.1,3.9,1.9,6,2.5c0.4,0.2,0.9,0.2,1.3,0 c0.3-0.3,0.5-0.6,0.5-1c0.6-2.7,0.9-5.5,1.3-8.2c0.9-5,2.5-9.8,4.9-14.2c1.3-2.5,5.7-11.6,8.5-5.9c0.8,1.7,1.6,3.3,2.4,5 c0.5,1.1,1,2.1,1.5,3.2c1.9,3.3,2.7,7.2,2.5,11C903.2,287.7,903.3,295.5,903.4,303.2z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M801.2,303.2h4.1l-2.3-7.7l-3.3-11.1c0,1.9-0.1,3.8-0.3,5.6 c-0.5,3.9-1.6,7.6-3.3,11.1c-0.3,0.7-0.7,1.4-0.9,2.1H801.2L801.2,303.2z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M884.6,279.5c-0.6,1.6-0.1,3.3,0.4,4.9c1.3,4.6,1.9,9.4,1.8,14.2 c0.1,0.3-0.1,0.6-0.4,0.6c-0.1,0-0.1,0-0.2,0c-1.9,0.1-4,0.1-5.3-1.3L884.6,279.5z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 142.9,
  fill: "#C5C4CC",
  width: 422.2,
  height: 286
}), /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 169.1,
  fill: "#F2F2F2",
  width: 125,
  height: 136.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 249.1,
  y: 169.1,
  fill: "#F2F2F2",
  width: 120.5,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 48.4,
  y: 326.4,
  fill: "#F2F2F2",
  width: 42.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 48.4,
  y: 341.3,
  fill: "#F2F2F2",
  width: 122,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 220.6,
  y: 199.1,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 220.6,
  y: 222.3,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 220.6,
  y: 245.5,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 220.6,
  y: 268.7,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 220.6,
  y: 291.9,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 220.6,
  y: 315.1,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 220.6,
  y: 338.3,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3DEE7",
  d: "M168.6,306.1h-16.3c-1.3-3.4-2.4-6.8-3.3-10.2c-0.6-4.1-2.5-7.8-5.3-10.8c-0.9-1-1.6-2-2.3-3.1 c-1.4-2.7-1.9-5.8-1.4-8.8c0.1-0.8,0.2-1.7,0.4-2.5c0.7-3.2,1.9-6.3,2.9-9.4c0.4-1.3,1.6-2.2,2.9-2.4c1.1-0.2,2.2-0.1,3.2,0.4 c0.2,0.1,0.4,0.2,0.6,0.3c1.8,1.1,2.7,3.3,3.4,5.3c3.4,9.1,6.8,18.2,10.2,27.3c0.7,1.8,1.3,3.5,2,5.3c1,2.6,1.9,5.2,2.8,7.9 C168.4,305.6,168.5,305.9,168.6,306.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M100.9,186.3c-4,1.4-7.7,4.6-8.5,8.7c-0.4,1.9-0.1,4-0.5,5.9c-0.7,4.5-4.3,8-7.6,11.2s-6.7,6.9-6.9,11.5 c-0.3,5,3.4,9.7,2.7,14.7c-0.7,5.8-6.8,9.5-8.4,15.2c-1,3.8,0.2,7.8,2.3,11.1c3.9,6.3,10.5,10.6,17.6,12.9s14.6,2.8,22,2.9 c9,0.1,18.9-0.7,25.6-6.6c3.9-3.4,6.3-8.2,6.8-13.4c0.6-6.9-2.2-14-0.2-20.7c1.3-4.2,4.4-8,3.9-12.3c-0.5-4.2-4.2-7.3-6.7-10.7 c-2.4-3.2-3.8-7-5.2-10.7l-4.8-12.8c-1-2.5-2-5.1-4.1-6.8c-4-3.1-10.3-2.5-15-1.8C109.6,185.2,105,184.9,100.9,186.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A0616A",
  d: "M104.7,228.4c0,0,0.5,14.2-0.9,15.6s5.7,10.9,5.7,10.9l12.8-0.5l6.6-5.2l-5.7-7.6c0,0-2.4-12.3-0.5-15.1 S104.7,228.4,104.7,228.4z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M104.7,228.4c0,0,0.5,14.2-0.9,15.6s5.7,10.9,5.7,10.9l12.8-0.5l6.6-5.2 l-5.7-7.6c0,0-2.4-12.3-0.5-15.1S104.7,228.4,104.7,228.4z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#A0616A",
  cx: 112.5,
  cy: 216.8,
  r: 17
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3DEE7",
  d: "M121.2,306.1H135c0.5-0.9,1-1.9,1.6-2.8l0,0c0.6-1.1,1.5-2,2.5-2.6c0.7-0.3,1.3-0.7,1.9-1.1 c0.6-0.6,0.9-1.3,1.1-2.1c1-3,1.5-6.1,1.6-9.2c0-1,0-2.1,0.1-3.2c0-0.8,0.1-1.6,0.3-2.4c0.5-1.6,1.2-3.2,2-4.6 c1.9-3.4,3.7-6.8,5.6-10.2c0.3-1,0.5-2,0.4-3c0-1.4-0.5-2.7-1.2-3.8c-0.3-0.5-0.5-0.9-0.8-1.4c-1.2-1.8-2.5-3.6-4-5.1 c-3.2-3.4-7.1-6-11.4-7.7c-0.5-0.2-1.1-0.4-1.5-0.7c-0.6-0.5-1-1-1.4-1.7c-1.5-2.3-3.3-4.8-6-4.6c-0.9-0.4-1.9-0.5-2.9-0.2 c-0.1,0-0.3,0.1-0.4,0.1c-1,0.5-2,1-3,1.6c-2.5,1.3-5.3,1.8-8.1,1.5c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.2-0.6-0.4-0.9-0.7 c-1.4-1.1-3.3-1.4-5-0.8c-0.8,0.3-1.5,0.8-2,1.4c-0.5,0.6-0.8,1.4-1.4,2c-1.4,1.5-3.8,1.6-5.8,1.6c-4.3-0.1-8.6,0.3-12.8,1.2 c-3.7,0.8-7.1,2.5-10.1,4.9l0,0c-0.4,0.3-0.8,0.7-1.2,1.1c-0.9,0.8-1.5,1.8-2,2.8c-0.6,1.5-0.5,3.1-1,4.6c-0.6,1.7-1.8,3-2.3,4.7 c-0.4,1.3-0.3,2.7-1,3.8c0,0,0.1,0,0.1,0.1c2.7,2.4,5.1,5.5,7.8,7.9c1.6,1.2,2.9,2.7,4,4.4c0.2,0.4,0.4,0.8,0.5,1.2 c0.3,1.4,0.4,2.9,0.4,4.4c0.3,7,4.1,13.3,8.4,18.9c0.1,0.1,0.2,0.2,0.3,0.3h34.7V306.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3DEE7",
  d: "M76.8,281.3c-0.6,4.5-1.3,8.9-1.9,13.4c-0.3,2.4-0.7,4.8-1.3,7.1c-0.4,1.4-0.9,2.9-1.2,4.3H52.8 c0-0.8,0.1-1.6,0.2-2.4c0.5-2.9,1.3-5.7,2.4-8.4c2.3-6.1,4.5-12.3,6.8-18.4c1-2.6,1.8-5.3,2.9-7.9c0.2-0.5,0.4-1,0.6-1.4 c1.1-2.5,4.3-1.5,6.6-1.1c0.6,0.1,1.3,0.3,1.8,0.5c0.7,0.4,1.3,1,1.7,1.6c2.2,3.3,1.7,7.6,1.2,11.5 C76.9,280.5,76.8,280.9,76.8,281.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M136.6,303.4c0,0.1,0.4,1.2,0.9,2.8h-16.3C129.2,304.8,136.6,303.3,136.6,303.4L136.6,303.4z"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#2F2E41",
  cx: 113.9,
  cy: 206.8,
  rx: 18.4,
  ry: 9.9
}), /*#__PURE__*/React.createElement("rect", {
  x: 290.5,
  y: 248.2,
  fill: "#3F3D56",
  width: 422.2,
  height: 286
}), /*#__PURE__*/React.createElement("rect", {
  x: 317.4,
  y: 274.4,
  fill: "#F2F2F2",
  width: 125,
  height: 136.3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M357.7,337c0.8,0.3,1.7-0.1,2.2-0.9c1.7-2.7-1.5-6.2-0.8-9.4c0.6-2.5,3.4-4,4-6.5c0.6-2.4-1.2-5.2,0-7.4 c0.9-1.7,3.3-2.2,5.2-1.9s3.8,1.2,5.8,1.3c2.6,0.2,5.1-1,7.7-1.6s5.7-0.3,7.2,1.8c1.9,2.8,0,6.6,0.6,9.9c0.5,2.6,2.7,4.8,2.8,7.5 c0,1-2.5,0.2-2.3,1.1c0.1,0.9-1,0.1-0.1,0c0.8-0.2,1.4-0.9,1.4-1.7c0.1-0.8,1.6-1,1.6-1.8c0-1.9,3.3-0.6,3.9-2.4 c1.3-4.1,1-8.6-0.7-12.5c-0.9-1.6-1.6-3.3-2.1-5.1c-0.5-2.5,0.3-5.1-0.5-7.5c-1.1-3.2-4.7-4.8-8.1-5.2s-6.8,0.3-10.1-0.2 c-3-0.4-5.9-1.7-8.9-1.5c-3.6,0.2-6.8,2.6-9.3,5.2s-4.6,5.6-7.5,7.9c-0.9,0.6-1.7,1.3-2.4,2.1c-1.5,1.8-1.6,4.3-1.2,6.6 c0.4,2.3,1.3,4.4,1.7,6.7c0.3,2.1,0.2,4.3,0.4,6.4c0,2.2,0.7,4.3,1.9,6.1c1.1,1.4,2.7,2.3,4.5,2.3c0.6,0,1.1-0.5,1.7-0.4 C356.7,335.9,357,336.7,357.7,337z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#575A89",
  d: "M330.2,411.4c0.5-7.5,1-13.1,1-13.1l3.5-9.3l11.3,22.4H330.2z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M330.2,411.4c0.5-7.5,1-13.1,1-13.1l3.5-9.3l11.3,22.4H330.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A0616A",
  d: "M356.5,337.7c0,0,10.6,26.9,4.5,32s34-8.7,34-8.7l-1-3.5c0,0-13.1-5.1-6.7-19.9 C393.7,323,356.5,337.7,356.5,337.7z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M356.5,337.7c0,0,10.6,26.9,4.5,32s34-8.7,34-8.7l-1-3.5c0,0-13.1-5.1-6.7-19.9 C393.7,323,356.5,337.7,356.5,337.7z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#A0616A",
  cx: 371.6,
  cy: 326.2,
  r: 22.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#575A89",
  d: "M426,374.6c0,0-0.1,1.8-0.2,4.9c-0.3,6.3-0.9,18.2-1.5,31.9h-87c-2.3-3-4.1-6.4-5.5-9.9 c-0.4-1-0.6-2.1-0.7-3.2c-0.5-8.5,7.1-20.4,12.5-21.5c6.1-1.3,17.6-13.5,17.6-13.5c0.1,0.9,0.6,1.8,1.5,2.2l0,0 c0.9,0.5,2,0.7,3,0.7c3.8,0,20.3-7.6,25.6-10.1c1-0.5,1.6-0.8,1.6-0.8c6.1,2.6,12.4,4.8,18.9,6.4 C418.5,363.4,423.8,368.2,426,374.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M353.9,334.7c0.8,0.3,1.7-0.1,2.2-0.9c1.7-2.7-1.5-6.2-0.8-9.4c0.6-2.5,3.4-4,4-6.5c0.6-2.4-1.2-5.2,0-7.4 c0.9-1.7,3.3-2.2,5.2-1.9s3.8,1.2,5.8,1.3c2.6,0.2,5.1-1,7.7-1.6s5.7-0.3,7.2,1.8c1.9,2.8,0,6.6,0.6,9.9c0.5,2.6,6.6,4.5,7.2,2.7 c1.3-4.1,1-8.6-0.7-12.5c-0.9-1.6-1.6-3.3-2.1-5.1c-0.5-2.5,0.3-5.1-0.5-7.5c-1.1-3.2-4.7-4.8-8.1-5.2s-6.8,0.3-10.1-0.2 c-3-0.4-5.9-1.7-8.9-1.5c-3.6,0.2-6.8,2.6-9.3,5.2s-4.6,5.6-7.5,7.9c-0.9,0.6-1.7,1.3-2.4,2.1c-1.5,1.8-1.6,4.3-1.2,6.6 c0.4,2.3,1.3,4.4,1.7,6.7c0.3,2.1,0.2,4.3,0.4,6.4c0,2.2,0.7,4.3,1.9,6.1c1.1,1.4,2.7,2.3,4.5,2.3c0.6,0,1.1-0.5,1.7-0.4 C352.8,333.7,353.2,334.4,353.9,334.7z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M437.1,411.4h-25.4c-1.9-14.2-3.5-29-3.5-29l5.1-2.2l10.4-5.6 c0,0,0.8,1.8,2,4.9C428.4,386.1,433.2,398.5,437.1,411.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#575A89",
  d: "M439.4,411.4h-28.6c-4.2-15.5-8.4-32.3-8.4-32.3l10.9-8l12.8,3.5C426,374.6,433.5,392.5,439.4,411.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 519.6,
  y: 274.4,
  fill: "#F2CD5D",
  width: 120.5,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 318.9,
  y: 431.6,
  fill: "#F2CD5D",
  width: 42.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 318.9,
  y: 446.6,
  fill: "#F2CD5D",
  width: 122,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.1,
  y: 304.4,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.1,
  y: 327.6,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.1,
  y: 350.8,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.1,
  y: 374,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.1,
  y: 397.2,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.1,
  y: 420.4,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 491.1,
  y: 443.6,
  fill: "#F2F2F2",
  width: 173.7,
  height: 8.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#57B894",
  d: "M681.7,467.8l-36.4,36.4L630,488.9c-2-2-5.4-2-7.4,0l-0.5-0.8c-2,2-1.5,6.2,0.5,8.2l19.8,19.8 c1.6,1.6,4.1,1.6,5.6,0l41-40.9c2-2,2.8-5.8,0.7-7.8l0,0C687.8,465.3,683.8,465.8,681.7,467.8z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M681.7,467.8l-36.4,36.4L630,488.9c-2-2-5.4-2-7.4,0l-0.5-0.8 c-2,2-1.5,6.2,0.5,8.2l19.8,19.8c1.6,1.6,4.1,1.6,5.6,0l41-40.9c2-2,2.8-5.8,0.7-7.8l0,0C687.8,465.3,683.8,465.8,681.7,467.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#57B894",
  d: "M681.7,466.2l-36.4,36.4L630,487.3c-2-2-5.4-2-7.4,0l0,0c-2,2-2,5.4,0,7.4l0,0l19.8,19.8 c1.6,1.6,4.1,1.6,5.6,0l41-40.9c2-2,2-5.3,0-7.4l0,0l0,0C687.1,464.2,683.8,464.2,681.7,466.2z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M1027.6,697.6c0,53.5-74.6,37-166,37s-164.9,16.6-164.9-37s74.6-65.2,166-65.2 S1027.6,644.1,1027.6,697.6z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M1027.6,687.6c0,53.5-74.6,37-166,37s-164.9,16.6-164.9-37s74.6-65.2,166-65.2S1027.6,634.1,1027.6,687.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC1C7",
  d: "M775.7,519.9l-3.4,3.9c0,0-41.1,3.9-39.4,10.5s49.5-8.9,49.5-8.9L775.7,519.9z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2CD5D",
  d: "M850.2,516.6c0,0-43.9,15.6-67.9,8.9l11.1,22.2c0,0,56.7-1.7,66.7-11.7S850.2,516.6,850.2,516.6z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M850.2,516.6c0,0-43.9,15.6-67.9,8.9l11.1,22.2c0,0,56.7-1.7,66.7-11.7 S850.2,516.6,850.2,516.6z"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFC1C7",
  cx: 820.4,
  cy: 367.8,
  r: 29.5
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC1C7",
  d: "M845.6,395.5c1,1.9,2.3,3.7,3.8,5.3c4,4.4,8.9,8,14.2,10.6c-16.7,3.4-33.6,5.9-50.6,7.5 c1.8-6.3-0.6-13.1-3.7-18.8S802,389,800,382.7l19.9,0.5c3.6,0.1,7.2,0.2,10.9,0c2.7-0.1,7.2-1.8,9.7-1.2 C845.8,383.4,843.2,390.7,845.6,395.5z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M912.5,533.8l16.7,20c0,0,27.8,65.1-32.8,71.7s-105.7-5-105.7-5s-24.5-11.7-25-2.8s-2.8,33.9-16.1,58.4 l-11.7,26.7c0,0-6.1,6.1-4.4,14.5s-37.3,11.1-36.7,0c0,0,5.6-9.5,5.6-15s8.9-18.9,8.9-18.9l16.1-80.1c0,0-1.1-41.2,36.7-33.4 s91.8-1.7,91.8-1.7l12.2-42.8L912.5,533.8z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  enableBackground: "new    ",
  d: "M912.5,533.8l16.7,20c0,0,27.8,65.1-32.8,71.7s-105.7-5-105.7-5 s-24.5-11.7-25-2.8s-2.8,33.9-16.1,58.4l-11.7,26.7c0,0-6.1,6.1-4.4,14.5s-37.3,11.1-36.7,0c0,0,5.6-9.5,5.6-15s8.9-18.9,8.9-18.9 l16.1-80.1c0,0-1.1-41.2,36.7-33.4s91.8-1.7,91.8-1.7l12.2-42.8L912.5,533.8z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M849.9,532.3c0,0,50.9-19.1,79.3,21.5c0,0,7.2,62.8-21.7,65.6s-66.7,2.2-75.6-7.2S766.8,576,766.8,576 s-28-14.3-33.4,4.3s-6,23-6,23s-28.9,21.1-40.6,25c0,0-7.8,11.1-12.2,11.1s-31.7,6.1-28.9-14.5l45-41.2l45-43.9 c0,0,12.8-18.9,45.6-8.9c21.8,6.5,43.9,11.9,66.2,16.1L849.9,532.3z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#CBCEDA",
  d: "M731.7,716.2c0,0,10.6,26.7,1.7,30s-27.8,1.1-27.8,1.1s-22.2-2.8-27.8-2.2s-28.4-3.9-25-12.8 s20.6-6.7,20.6-6.7l15.6-7.2c0,0,1.7-5.6,5.6-3.3S709.5,725.7,731.7,716.2z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#CBCEDA",
  d: "M673.9,637.3c0,0,11.7,26.1-7.2,23.9s-33.4-6.1-38.9-6.7c-5.3-0.5-20.5-5.7-18.2-16c0.1-0.7,0.2-1.3,0.2-2 c0-1.4,1.9-4.1,16.9-3.7c0,0,11.1,0,15.6-7.8C642.2,625,658.9,646.2,673.9,637.3z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2CD5D",
  d: "M800.1,414.8c0,0,40-25,73.4,0s55.6,139,55.6,139l-77.3-17.2c0,0-3.3-13.3-7.8-15.6s-5-11.7-5-11.7 s-23.9-7.2-22.2-35S800.1,414.8,800.1,414.8z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2CD5D",
  d: "M820.7,415.9h-20.6c0,0-12.2,13.9-13.9,48.9l-6.7,27.8c0,0-13.9,33.4-5.6,38.9s24.5,5,27.8-6.1 s26.1-75.6,26.1-75.6L820.7,415.9z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M814.8,329.4c10.4-4.3,22.3-2.3,30.8,5.1c10.7,9.5,12.8,25.1,15.5,39.1c2.7,14.1,8.1,29.7,21.4,35.1 c-6,0.8-12,0.6-18-0.5l20,17.9l-33.7-11c-10.6-3.5-21.7-6.9-32.7-5c-18.2,3.2-30.8,20.3-48.2,26.3l1.9-9.5l-11.7-0.1 c2.8-2.1,5.1-4.8,6.7-7.9c-1.1-1.4-2.7-2.2-4.5-2.3c-4.9-30.4,13.2-60.5,36.7-80.4c4.6-3.9,9.8-7.7,15.7-8.6c6-1,13,1.7,15,7.4"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M244.5,608.3c0,64,40.2,115.8,89.8,115.8"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2CD5D",
  d: "M334.3,724.1c0-64.7,44.8-117.1,100.2-117.1"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2CD5D",
  d: "M277,614.1c0,60.8,25.6,110,57.3,110"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M334.3,724.1c0-82.7,51.8-149.7,115.8-149.7"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#A8A8A8",
  d: "M315.4,724.9c0,0,12.7-0.4,16.6-3.1s19.6-6,20.5-1.6s19.1,21.8,4.8,21.9s-33.4-2.2-37.2-4.6 S315.4,724.9,315.4,724.9z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  enableBackground: "new    ",
  d: "M357.5,740.6c-14.4,0.1-33.4-2.2-37.2-4.6c-2.9-1.8-4.1-8.2-4.5-11.1 c-0.3,0-0.4,0-0.4,0s0.8,10.3,4.6,12.6s22.9,4.7,37.2,4.6c4.1,0,5.6-1.5,5.5-3.7C362.2,739.7,360.6,740.6,357.5,740.6z"
});

var SvgUndrawHireTe5Y = function SvgUndrawHireTe5Y(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b225c2ac-b0fc-4c56-8095-6e63207963c3",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1068.6 800",
    enableBackground: "new 0 0 1068.6 800",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUndrawHireTe5Y, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_hire_te5y.d8a53881.svg";
export { ForwardRef as ReactComponent };